module.exports = __webpack_public_path__ + "static/media/tick.1fcabea6.svg";